/*****
  ARGV=> 
    backserver: "https://wwwv02.fistek.com/newfistek/index.php"
    sno: 2330
    exc: "1"
    sexc:"0"
    sel_line: "linegrd" "kline" "ohlc"
    sel_time: "1i"
    submenu: "category/1:2317:0"
    user: "guest" "登入者帳號"
******/

import { createChart } from "lightweight-charts";
import { getUrlParams,showTip,src_resize,showNoDataMessage,hideNoDataMessage,leadingNumbers,mergeArrays,showOverlay,hideOverlay,updateNoDataMessage } from './lib/util';
import config from './config/config.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

//未測試
//import fs from 'fs';
//setInterval(() => {
//    const memoryUsage = process.memoryUsage();
//    const log = `[${new Date().toISOString()}] Memory Usage:
//    RSS: ${(memoryUsage.rss / 1024 / 1024).toFixed(2)} MB,
//    Heap Total: ${(memoryUsage.heapTotal / 1024 / 1024).toFixed(2)} MB,
//    Heap Used: ${(memoryUsage.heapUsed / 1024 / 1024).toFixed(2)} MB,
//    External: ${(memoryUsage.external / 1024 / 1024).toFixed(2)} MB\n`;
//
//    fs.appendFileSync('memory-usage.log', log);
//    console.log('Memory usage logged.');
//}, 5000);

export const params = getUrlParams();
if( params['sel_time'] == '1d' || params['sel_time'] == '1w' || params['sel_time'] == '1m' ) params['sel_time'] = params['sel_time'].toUpperCase(); 
console.log("params",params);

const displayedMonths = new Set();
const displayedYears = new Set();
const chartContainer = document.getElementById('container');
const chart = createChart(chartContainer, config.chartOptions);
const CANDLE_WIDTH = 6;
let interval = "1i";
let seriestype = "areaSeries"; //areaSeries,candleSeries,barSeries 對映 "linegrd" "kline" "ohlc"
if( params['sno'] == undefined ) params['sno']="2330";
if( params['exc'] == undefined ) params['exc']=1;
if( params['interval'] != undefined ) interval = params['interval'];
if( params['seriestype'] != undefined ) seriestype = params['seriestype'];
if( params['sel_time'] ) interval = params['sel_time'];
if( params['sel_line'] ){
    if( params['sel_line'] == 'line' || params['sel_line'] == 'linegrd' ){
        seriestype = "areaSeries";
    }else if( params['sel_line'] == 'kline' ){
        seriestype = "candleSeries";
    }else if( params['sel_line'] == 'ohlc' ){
        seriestype = "barSeries";
    }
}
let currentSeries;
let volumeSeries;
let candleSeries;
let seriesData;
let candleData = new Map();
let linesData = new Map();
let volData = new Map();
let ohlcData= {};
let stocks = {};    
let dataMinTime = {};  //key=interval, value=unixtime
let opts = {}; 
let st= 200;     //筆數
let period = 2;  //period=周期 [ 1: 分, 2: 日 3: 周, 4: 月]
let gap = 1;     //period=1 & gap=10 表示10分鐘
let strings = [];
let url;
let fi;
let isRangeChange = false;  //true正在處理範圍改變(左右滑動)
let isCrosshair = false;    //判斷查價線是否開啟
let isShowTip = true;
let datas = {'candle':{},'line':{},'volume':{}};
let tdatas = {'candle':{},'line':{},'volume':{}};
let his_last_datas;         //his查回的最後一筆資料
let his_lastdate;           //his查回的資料時間
let resize = false;
//let timestamp = 'unix';     //資料以什麼格式傳送 
const interval2period = {"1D":2,"1W":3,"1M":4};
const t = new Date();
const year = t.getFullYear();
const month = String(t.getMonth() + 1).padStart(2, '0');
const day = String(t.getDate()).padStart(2, '0');
const today = `${year}${month}${day}`;
const lineWidth = 2;
let minPriceLine = null;
let maxPriceLine = null;

import { twnTick,hisData,wsData,generateData } from './lib/datas';

let ws = null;
let ws_auto_loop = 0;       //自動連線的次數
const message = "((type=reg.sno;rseq=tv;e=1;exc="+params['exc']+";sno="+params['sno']+";))";
const clr_message = "((type=reg.clr;rseq=tv;e=1;exc="+params['exc']+";sno="+params['sno']+";))";

//Data/FileSrvData/$isno/st資料筆數/period周期/exc/gap/sexc/ed/sd (get資料ed沒有用, 都是到今日)
//var url = 'https://www.vbroker.net/newfistek/index.php/Data/FileSrvData/2330/1000/1/1/1/0/20240730';
//let url = "https://www.vbroker.net/newfistek/index.php/Data/FileSrvData/2330/300/2/1/1/0/20240730";    //每日
//var url = 'https://www.vbroker.net/newfistek/index.php/Data/twntick2/2330/1/0/0/0/2/1/0';
(async () => {

    //中文名
    strings = [config['getData']['stkname'],params['sno'],params['exc']];  //exc=1/2/12
    url = strings.join('/');
    stocks = await getData(url,'stkname');
    if( stocks.name == null ){
        alert('查無此股票代碼');
        return;
    }
    document.getElementById('title').innerHTML = [stocks.sno,stocks.name].join(" ");

    strings = [config['getData']['init'],params['sno'],params['exc'],stocks['sexc']];
    url = strings.join('/');
    opts = await getData(url,'init');  //交易基本資料 base/init
    fi = opts['init']['fi'];

    period = (!interval2period[interval])?'1':interval2period[interval];
    gap = leadingNumbers(interval);
    await checkData(interval,seriestype);
    createSelect();
    createIntervalSelect(seriesData,volData);
    createSeriesSelect();
    chart.subscribeCrosshairMove(param => {
        if (
            param.point === undefined ||
            !param.time ||
            param.point.x < 0 ||
            param.point.x > container.clientWidth ||
            param.point.y < 0 ||
            param.point.y > container.clientHeight
        ) {
            isCrosshair = false;
            console.log('查價線已關閉');            
            const visibleRange = chart.timeScale().getVisibleRange();
            if( datas['candle'].length == 0 ){
            }else{
                const latestDataTime = datas['candle'][datas['candle'].length - 1].time;
                if (visibleRange && visibleRange.to >= latestDataTime) {
                    console.log('目前停在最新資料');
                    isShowTip = true;
                    let lastData = ohlcData[ohlcData.length - 1];
                    showTip(lastData,period);
                } else {
                    console.log('目前不在最新資料');
                    isShowTip = false;
                }    
            }
            return;
        } else {

            if (!param || !param.time) {
                return;
            }
            const ohlc = ohlcData.find(item => item.time === param.time);
            showTip(ohlc,period);
            isCrosshair = true;
            //console.log('查價線已啟動，顯示數據:', param);
        }
    });
    if( params.user != 'guest' && params.user != '' ) WebSocketClient();
    src_resize(chart,ohlcData[ohlcData.length - 1],period);  
})();
//window.addEventListener("load", auto_connect, false);
window.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
        //console.log('頁面重新可見');
        auto_connect();
    } else if (document.visibilityState === 'hidden') {
        //console.log('頁面被隱藏');
    }
},false);
window.addEventListener('resize', async () => {
    if( !chart ) return;  
    await adjustBarSpacing();
    await src_resize(chart,ohlcData[ohlcData.length - 1],period);
    window.setTimeout(updatePriceLines, 1000);
});
window.addEventListener('dblclick', () => {
    window.history.back();
});

function WebSocketClient()
{
    ws = new WebSocket(config.wsServer);
    ws.onopen = function() {
        console.log('ws Connected');
        sendMessage(message);
        ws_auto_loop = 0;
    };
    ws.onmessage = function(event) {
        if( event.data.match(/type\=conn\.hbt/) ){ return; }
        if( isRangeChange == true ) return;
        if( stocks.sno == '3019' ){
        console.log('receive:', event.data);
        }        
        if( currentSeries && volumeSeries ){
            let linedata = wsData(event.data,period,gap,opts,tdatas['candle'][tdatas['candle'].length-1]);
            
            if( linedata != undefined ){                
                //數據整合

//console.log("before",datas['candle'][datas['candle'].length-1]['time'],linedata['candle']['time']);
//console.log("before line",datas['line'][datas['line'].length-1]['time'],linedata['line']['time']);
//console.log("before vol",datas['volume'][datas['volume'].length-1],linedata['volume']);
//console.log("linedata",linedata);            

                if( datas['candle'].length>0 && datas['candle'][datas['candle'].length-1]['time']==linedata['candle']['time'] ){
                    //console.log('同筆');
                    let tkey = datas['candle'].length-1;
                    if( datas['candle'][tkey]['high'] < linedata['candle']['high'] ) datas['candle'][tkey]['high']=linedata['candle']['high'];
                    if( datas['candle'][tkey]['low'] > linedata['candle']['low'] ) datas['candle'][tkey]['low']=linedata['candle']['low'];
                    datas['candle'][tkey]['close'] = linedata['candle']['close'];
                    let tkey2 = datas['candle'].length-2;                    
                    if( datas['candle'][tkey2] ){
                        datas['candle'][tkey]['updn'] = parseFloat((datas['candle'][tkey]['close'] - datas['candle'][tkey2]['close']).toFixed(2));
                        let color = "#AAAAAA";    
                        if( datas['candle'][tkey]['updn'] > 0 ){
                            color = "#ef5350";
                        }else if( datas['candle'][tkey]['updn'] < 0 ){
                            color = '#26a69a';
                        }
                        linedata['volume']['color'] = color;
                    }
                    if( seriestype == 'candleSeries' || seriestype == 'barSeries' ){
                        let updn = datas['candle'][tkey]['updn'];
                        let color;
                        if( datas['candle'][tkey]['open'] == datas['candle'][tkey]['close'] ){
                            color = "#FFFFFF";
                        }else if( updn < 0 ){
                            color = "#01B468";
                        }else if( updn > 0 ){
                            color = "#EA0000";
                        }
                        datas['candle'][tkey]['color'] = color;
                        datas['candle'][tkey]['wickColor'] = color;
                        datas['candle'][tkey]['borderColor'] = color;
                    }
                    datas['line'][tkey]['value'] = linedata['line']['value'];
                    if( period == 2 ){
                        datas['volume'][tkey]['value'] = linedata['volume']['value'];
                    }else if( period == 3 || period==4 ){
                        datas['volume'][tkey]['value'] = his_last_datas['uvol'] + linedata['volume']['value'];
                    }else{
                        datas['volume'][tkey]['value'] = datas['candle'][datas['candle'].length-1]['uvol'] + linedata['volume']['value'];
                    }
                    datas['volume'][tkey]['color'] = linedata['volume']['color'];
                    datas['candle'][tkey]['ltime'] = linedata['candle']['ltime'];
                    datas['candle'][tkey]['uvol'] = datas['volume'][tkey]['value'];
                    linedata = {'candle':datas['candle'][tkey],'line':datas['line'][tkey],'volume':datas['volume'][tkey]}

                }else{

                    let tkey = datas['candle'].length-1;
                    if( datas['candle'][tkey] ){
                        linedata['candle']['updn'] = parseFloat((linedata['candle']['close'] - datas['candle'][tkey]['close']).toFixed(2));
                    }

                    //console.log('新筆1',datas['candle'].length);
                    datas['candle'].push(linedata['candle']);
                    datas['line'].push(linedata['line']);
                    datas['volume'].push(linedata['volume']);
                    //console.log('新筆2',datas['candle'].length);
                }
                updateNoDataMessage(datas['candle']);
                
                candleData.set(interval, datas['candle']);
                linesData.set(interval, datas['line']);
                volData.set(interval, datas['volume']);
                ohlcData = candleData.get(interval);
                
                chart.timeScale().unsubscribeVisibleLogicalRangeChange(onLogicalRangeChange);
                if( seriestype == 'candleSeries' ){
                    currentSeries.update(linedata['candle']);
                }else if( seriestype == 'barSeries' ){
                    currentSeries.update(linedata['candle']);
                }else if( seriestype == 'areaSeries' ){
                    currentSeries.update(linedata['line']);
                }
                volumeSeries.update(linedata['volume']);
                updatePriceLines(); //high/low
                if( isShowTip == true && isCrosshair == false ){
                    chart.timeScale().scrollToRealTime();                     
                    let lastData = ohlcData[ohlcData.length - 1];
                    showTip(lastData,period);
                }    
                chart.timeScale().subscribeVisibleLogicalRangeChange(onLogicalRangeChange);
                
                //if( isCrosshair == false ){
                //    let lastData = ohlcData[ohlcData.length - 1];
                //    showTip(lastData,period);                    
                //    chart.timeScale().scrollToRealTime(); 
                //}                
            }
        }
    };
    ws.onclose = function() {
        console.log('ws Connection closed');
        //if( (typeof user)=="undefined" || user == 'guest' ){
        //    //不連續查價不需重連
        //}else{
            if( ws_auto_loop == 0 ){
                auto_connect();
            }else{
                setTimeout(auto_connect, 3000);
            }
        //}        
    };
    ws.onerror = function(error) {
        console.error('WebSocket error:', error);
    };
}

function sendMessage(message) {
    if( ws ){
        console.log("send message",message);
        ws.send(message);
        //console.log('Message sent to server:', message);
    } else {
        console.log('WebSocket is not open. Cannot send message.');
    }
}

function auto_connect()
{
    if( params.user == 'guest' || params.user == '' ) return;
    if( ws_auto_loop >= 5 )return;
console.log("auto_connect ws_auto_loop="+ws_auto_loop);    
    if( !ws || ws.readyState != 1 ){
        WebSocketClient();
        ws_auto_loop++;
    }
}


/////////////////////////////////////////////////////////////////
// type=stkname / tick(當日) / his(歷史)
async function getData(url,type){
  return new Promise(async (resolve)=>{ 
    isRangeChange = true;
    let fetch_url = url;
//console.log("url",url,"type="+type);
    if (window.location.protocol === 'https:') {
        fetch_url = config['httpsProxyHost'] + `?url=${encodeURIComponent(url)}`;        
    }else{
        if (config['proxyHost'].trim().length != 0) {
            fetch_url = config['proxyHost'] + `?url=${encodeURIComponent(url)}`;        
        }
    }
    showOverlay();
    await fetch(fetch_url)
    //await fetch(url)
        //.then(response => response.text())
        .then(response => response.json())
        .then(data => {
            let datas = {};
            switch (type) {
              case 'stkname':
                datas = data;
                break
              case 'tick':
                datas = twnTick( data['rs']['datas'],period,params['exc'] );
                break;
              case 'his':
                his_lastdate = data['lastdate'];
                datas = hisData( data['rs'],period,params['exc']);
                break;
              case 'init':
                datas = data.rs;
                break;
              default:
                break;
            }            
            isRangeChange = false;
            resolve(datas);
        })
        .catch(error => {
            console.error('Error fetching the file:', error);
            isRangeChange = false;
        })
        .finally(() => {
            hideOverlay();
        });
    });
}

async function setChartInterval(interval,seriestype,seriesData,volData) 
{
    return new Promise(async (resolve)=>{
        //console.log( interval,seriestype,seriesData,volData );
        chart.timeScale().unsubscribeVisibleLogicalRangeChange(onLogicalRangeChange);
        if( seriestype == 'candleSeries' ){
            await switchChartType(createCandlestickSeries,seriesData);
        }else if( seriestype == 'barSeries' ){
            await switchChartType(createBarSeries,seriesData);
        }else if( seriestype == 'areaSeries' ){
            await switchChartType(createAreaSeries,seriesData);
        }else{
            await switchChartType(createlineSeries,seriesData);
        }
        createHistogramSeries(volData);        
        updatePriceLines();
        //chart.timeScale().fitContent(); //使用此方法 barspacing 會沒做用
        chart.timeScale().scrollToPosition(0);
        chart.timeScale().subscribeVisibleLogicalRangeChange(onLogicalRangeChange);
    });
}
// 根據容器的寬度和蠟燭的寬度計算合適的 barSpacing
function adjustBarSpacing() {
    const chartWidth = container.clientWidth;  // 當前容器的寬度
    const barsOnScreen = chartWidth / CANDLE_WIDTH;  // 計算能在螢幕上顯示的蠟燭數量
    const barSpacing = chartWidth / barsOnScreen;  // 根據蠟燭數量計算 barSpacing
    chart.applyOptions({
        timeScale: {
            barSpacing: barSpacing,
        },
    });
}
function tick_zoom(){
    
    showOverlay();
    //window.history.back();
    //return;
    
    let INDEX_PATH = config['vbServer'];
    if( params['backserver'] ) INDEX_PATH = params['backserver'];
    //if( INDEX_PATH.indexOf("wwwv02") > -1 || INDEX_PATH.indexOf("wwwV02") > -1 ){
    //    tick_zoom2();
    //    return;
    //}
    let cmd = "";
    if( params['exc'] && params['sno'].length==10 ){
        cmd = INDEX_PATH + "/TWoption/optquote?";
        if( params['function'] != undefined ){ cmd+= "&function="+params['function']; }
        if( params['comn'] != undefined ){ cmd+= "&comn="+params['comn']; }
        if( params['setm'] != undefined ){ cmd+= "&setm="+params['setm']; }
        cmd+= "&submenu=category/"+params['exc']+":"+params['sno'];
    }else if( params['exc']==2 || params['exc']==12 ){
        cmd = INDEX_PATH + "/TWfuture/ftcquote?";
        if( params['function'] != undefined ){ cmd+= "&function="+params['function']; }
        if( params['comn'] != undefined ){ cmd+= "&comn="+params['comn']; }
        if( params['setm'] != undefined ){ cmd+= "&setm="+params['setm']; }
        cmd+= "&submenu=category/"+params['exc']+":"+params['sno']+":"+params['sexc'];;
    }else if( params['submenu']!=undefined && params['submenu'].indexOf("indexcate")>=0 ){
        cmd = INDEX_PATH + "/TWquote/stockexch?submenu=indexcate/"+params['exc']+":"+params['sno']+":"+params['sexc'];
        if( params['exec'] != undefined ){ cmd+= "&exec="+params['exec']; }
    }else{
        cmd = INDEX_PATH + "/TWquote/stockquote?submenu=custom/"+params['exc']+":"+params['sno']+":"+params['sexc'];;
        if( params['sexc'] != undefined ){ cmd+= "&sexc="+params['sexc']; }
    }
    if( params['template'] ){
        cmd = cmd + "&template=" + params['template'];
    }
    if( interval=='1D' || interval=='1W' || interval=='1M' ) interval = interval.toLowerCase(); 
    let sel_line = "linegrd";
    if( seriestype=='areaSeries' ){
        sel_line = "linegrd";
    }else if( seriestype == 'candleSeries' ){
        sel_line = "kline";
    }else if( seriestype == 'barSeries' ){
        sel_line = "ohlc";
    }
    //cmd += "&sno="+params['sno'];
    //cmd += "&exc="+params['exc'];
    //cmd += "&sexc="+params['sexc'];
    cmd += "&sel_time="+interval;
    cmd += "&sel_line="+sel_line;
    if( INDEX_PATH.indexOf("wwwv02") > -1 || INDEX_PATH.indexOf("wwwV02") > -1 ){
        let da = {};
        da['url'] = cmd;
        da['action'] = "navigate";
        //console.log("da",da);
        try {
            console.log("aaa",da,cmd);
            window.parent.postMessage(da,cmd);           
        } catch (error) {
            console.log('網頁傳送失敗:', error);
            if( cmd != "" ) window.parent.location=cmd;
        }
    }else{
        console.log("bbb");
        if( cmd != "" ) window.parent.location=cmd;
    }
}
/*
function tick_zoom2(){
    let INDEX_PATH = config['vbServer'];
    if( params['backserver'] ) INDEX_PATH = params['backserver'];
    let cmd = "";
    let da = {};
    if( params['exc'] && params['sno'].length==10 ){
        cmd = INDEX_PATH + "/TWoption/optquote?";
        if( params['function'] != undefined ){ da['function']=params['function']; }
        if( params['comn'] != undefined ){ da['comn']=params['comn']; }
        if( params['setm'] != undefined ){ da['setm']=params['setm']; }
        da['submenu']="category/"+params['exc']+":"+params['sno'];
    }else if( params['exc']==2 || params['exc']==12 ){
        cmd = INDEX_PATH + "/TWfuture/ftcquote?";
        if( params['function'] != undefined ){ da['function']=params['function']; }
        if( params['comn'] != undefined ){ da['comn']=params['comn']; }
        if( params['setm'] != undefined ){ da['setm']=params['setm']; }
        da['submenu']="category/"+params['exc']+":"+params['sno']+":"+params['sexc'];
    }else if( params['submenu']!=undefined && params['submenu'].indexOf("indexcate")>=0 ){
        cmd = INDEX_PATH + "/TWquote/stockexch?";
        da['submenu']="indexcate/"+params['exc']+":"+params['sno']+":"+params['sexc'];
        if( params['exec'] != undefined ){ da['exec']=params['exec']; }
    }else{
        cmd = INDEX_PATH + "/TWquote/stockquote?";
        da['submenu']="custom/"+params['exc']+":"+params['sno']+":"+params['sexc'];
        if( params['sexc'] != undefined ){ da['sexc']=params['sexc']; }
    }
    if( params['template'] ){
        da['template']=params['template'];
    }
    da['url'] = cmd;
    da['action'] = "navigate";
    console.log("da",da);
    try {
        window.parent.postMessage(da,cmd);
        //if( cmd != "" ) window.parent.location=cmd;
    } catch (error) {
        if( cmd != "" ) window.parent.location=cmd;
        console.log('網頁傳送失敗:', error);
        //alert(error);
    }
}
*/
//連續線, 目前沒使用
function createLineSeries(seriesData) {
    //lineSeries = chart.addLineSeries({ color: intervalColors['1D'] });
    //const intervalColors = config.intervalColors;
    currentSeries = chart.addLineSeries();    
    currentSeries.setData(seriesData.get(interval));    
    setTimeScale();
}
//漸層連續線
function createAreaSeries(seriesData) 
{
    //currentSeries = chart.addAreaSeries({ lineColor: '#2962FF', topColor: '#2962FF', bottomColor: 'rgba(41, 98, 255, 0.28)' });            
    //currentSeries = chart.addAreaSeries({ lineColor: '#ce0000', topColor: '#ce0000', bottomColor: 'rgba(47, 0, 0, 0.28)' });
    currentSeries = chart.addAreaSeries({ 
        lineColor: '#FF8000', 
        topColor: '#FF8000', 
        bottomColor: 'rgba(47, 0, 0, 0.28)', 
        priceScaleId: 'right',
        scaleMargins: {
            top: 0.05,
            bottom: 0.3,
        },        
        priceFormat: {
          type: "custom",
          formatter: function (price) {
            return `${price.toFixed(fi)}`;
          },
        },
    });
    currentSeries.setData(seriesData.get(interval));
    setTimeScale();
}
//K線
function createCandlestickSeries(seriesData) 
{
    currentSeries = chart.addCandlestickSeries({
        //upColor: '#ef5350',  // 上漲蠟燭的顏色
        //downColor: '#26a69a',// 下跌蠟燭的顏色
        upColor: '#EA0000',  // 上漲蠟燭的顏色
        downColor: '#01B468',// 下跌蠟燭的顏色
        borderVisible: false,
        wickUpColor: '#EA0000',  // 上漲蠟燭影線的顏色
        wickDownColor: '#01B468',// 下跌蠟燭影線的顏色
        crossHairMarkerVisible: false,
        borderUpColor: '#EA0000', // 上漲蠟燭邊框的顏色
        borderDownColor: '#01B468', // 下跌蠟燭邊框的顏色        
        priceScaleId: 'right',  // 分配一個獨立的 priceScale 給蠟燭圖
        scaleMargins: {
            top: 0.05,
            bottom: 0.3,
        },        
        priceFormat: {
          type: "custom",
          formatter: function (price) {
            return `${price.toFixed(fi)}`;
          },
        },        
    });
    currentSeries.setData(seriesData.get(interval));    
    setTimeScale();     
}
//美國線
function createBarSeries(seriesData) 
{    
    //currentSeries = chart.addBarSeries({ upColor: '#26a69a', downColor: '#ef5350' });
    currentSeries = chart.addBarSeries({ 
        upColor: '#EA0000', 
        downColor: '#01B468',
        priceFormat: {
          type: "custom",
          formatter: function (price) {              
            return `${price.toFixed(fi)}`;
          },
        },        
        priceScaleId: 'right',
        scaleMargins: {
            top: 0.05,
            bottom: 0.3,
        },        
    });
    currentSeries.setData(seriesData.get(interval));    
    setTimeScale();   
}
function createHistogramSeries(seriesData)
{  
    if (volumeSeries) {
        chart.removeSeries(volumeSeries);
    }
    volumeSeries = chart.addHistogramSeries({
        color: '#26a69a',
        priceFormat: {
            type: 'volume',
        },
        priceScaleId: 'Histogram', 
        scaleMargins: {
            top: 0.75,
            bottom: 0,
        },
    });
    volumeSeries.setData(seriesData.get(interval));
    setTimeScale();    
//    adjustBarSpacing();
}
function switchChartType(createSeriesFunction,seriesData) 
{
    if (currentSeries) {
        chart.removeSeries(currentSeries);
    }
    createSeriesFunction(seriesData);
    let lastData = ohlcData[ohlcData.length - 1];
    showTip(lastData,period);
}
/****************
 設定其他按鈕選項
*****************/
function createSelect(){

    const buttonsContainer = document.getElementById('sel');
    const options = [
        { value: '', text: "<i class='fas fa-arrow-left'></i>" },
    ];
    options.forEach(optionData => {
        const button = document.createElement('button');
        button.innerHTML = optionData.text;
        button.value = optionData.value;
        button.addEventListener('click', () => tick_zoom());
        buttonsContainer.appendChild(button);
    });   
}    

function createSeriesSelect()
{
    const buttonsContainer = document.getElementById('seriestype');
    const dropdownMenu = document.createElement('div');
    dropdownMenu.classList.add('dropdown-menu');
    const options = [
        { value: 'areaSeries', text: '連續線' },
        { value: 'candleSeries', text: 'K線' },
        { value: 'barSeries', text: '美國線' }
    ];
    let series_text, series_value;
    options.forEach(optionData => {        
        const aLink = document.createElement('a');
        aLink.textContent = optionData.text;
        if( seriestype == optionData.value ){
            series_text = optionData.text;
            series_value = optionData.value;
            aLink.classList.add('dropdown-item','seriestype-select','active');
        }else{
            aLink.classList.add('dropdown-item','seriestype-select');
        }
        aLink.href = '#';        
        aLink.setAttribute('data-type', optionData.value);
        dropdownMenu.appendChild(aLink);
    });
    const button = document.createElement('button');
    button.innerText = series_text;
    button.value = series_value;
    button.classList.add('dropdown-toggle','series-trigger');
    button.setAttribute('data-bs-toggle', 'dropdown');
    buttonsContainer.appendChild(button);
    document.getElementById('seriestype').appendChild(dropdownMenu);
    
    const selectTrigger = document.querySelector('.series-trigger');
    const options1 = document.querySelectorAll('.seriestype-select');
    options1.forEach(option => {
        option.addEventListener('click', (e) => 
        {
            options1.forEach(opt => opt.classList.remove('active'));
            e.target.classList.add('active');
            selectTrigger.textContent = e.target.textContent;
            seriestype = e.target.getAttribute('data-type');
            seriesData = linesData;    
            if( seriestype == 'candleSeries' || seriestype == 'barSeries' ){
                seriesData = candleData;
            }
            setChartInterval(interval,seriestype,seriesData,volData)
        });
    });
}
function createIntervalSelect(seriesData,volData){

    const buttonsContainer = document.getElementById('interval');
    const dropdownMenu = document.createElement('div');
    dropdownMenu.classList.add('dropdown-menu');
    const options2 = [
        { value: '1i', text: '1分鐘' },
        { value: '2i', text: '2分鐘' },
        { value: '3i', text: '3分鐘' },
        { value: '4i', text: '4分鐘' },
        { value: '5i', text: '5分鐘' },
        { value: '10i', text: '10分鐘' },
        { value: '15i', text: '15分鐘' },
        { value: '30i', text: '30分鐘' },
        { value: '60i', text: '60分鐘' }
    ];
    let interval_text, interval_value;
    options2.forEach(optionData => {        
        const aLink = document.createElement('a');
        aLink.textContent = optionData.text;
        aLink.classList.add('dropdown-item','interval-select');
        aLink.href = '#';
        aLink.setAttribute('data-type', optionData.value);
        dropdownMenu.appendChild(aLink);
        if( optionData.value == interval ){
            interval_text = optionData.text;
            interval_value = optionData.value;
        }
    });
    const options = [
        { value: 'ii', text: '分鐘' },
        { value: '1D', text: '日線' },
        { value: '1W', text: '週線' },
        { value: '1M', text: '月線' }
    ];
    options.forEach(optionData => {
        const button = document.createElement('button');
        button.innerText = optionData.text;
        button.value = optionData.value;
        //button.addEventListener('click', () => setChartInterval(optionData.value,seriestype,seriesData,volData));
        const lastChar = interval.substring(interval.length - 1);
        if( button.value == interval || (lastChar == 'i' && button.value=='ii') ){
            button.classList.add("active");            
            if(lastChar == 'i' && button.value=='ii'){
                button.innerText = interval_text;
            }
        }
        if( optionData.value == 'ii' ){
            button.classList.add('dropdown-toggle','interval-trigger');
            button.setAttribute('data-bs-toggle', 'dropdown');
            buttonsContainer.appendChild(button);
        }else{
            button.addEventListener('click', () => checkData(optionData.value,seriestype));
            buttonsContainer.appendChild(button);
        }
        if( optionData.value == 'ii' ){
            buttonsContainer.appendChild(dropdownMenu);            
        }
    });   
    const buttons = document.querySelectorAll('.button-group button');
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            buttons.forEach(btn => {
                btn.classList.remove('active');
            });
            button.classList.add("active");
        });
    });
    const selectTrigger = document.querySelector('.interval-trigger');
    const options1 = document.querySelectorAll('.interval-select');
    options1.forEach(option => {
        option.addEventListener('click', (e) => {
            options1.forEach(opt => opt.classList.remove('active'));
            e.target.classList.add('active');
            selectTrigger.textContent = e.target.textContent;
            interval = e.target.getAttribute('data-type');          
            checkData(interval,seriestype);            
        });
    });
}    
async function fetchData(days) 
{
    let strings = '';
    if( days > 0){
        const date = new Date((datas['candle'][0]['time']-(86400*days)) * 1000); //每次100天
        const sd = `${date.getFullYear()}${('0' + (date.getMonth() + 1)).slice(-2)}${('0' + date.getDate()).slice(-2)}`;
        strings = [config['getData']['his'],params['sno'],st,period,stocks.exc,gap,stocks.sexc,today,sd];
    }else{
        strings = [config['getData']['his'],params['sno'],st,period,stocks.exc,gap,stocks.sexc,today];
    }
    url = strings.join('/');
    const dts = await getData(url,'his');
    return dts;
}

async function checkData(inter,seriestype)
{
    if( inter[inter.length - 1] != 'i' && document.querySelector('.interval-trigger') != null){
        document.querySelector('.interval-trigger').textContent = "分鐘";
    }
    interval = inter;
    if( seriestype == 'candleSeries' || seriestype == 'barSeries' ){
        seriesData = candleData;
    }else{
        seriesData = linesData;
    }
    displayedMonths.clear();
    displayedYears.clear();
    //if( seriesData.has(interval) ){
    //    setChartInterval(interval,seriestype,seriesData,volData);
    //    ohlcData = candleData.get(interval);
    //}else{
        isRangeChange = true;
        //sendMessage(clr_message);        
        period = (!interval2period[interval])?'1':interval2period[interval];
        gap = leadingNumbers(interval);
        let field;
        if( opts['init']['exc']==12 ) field = 'cdate';  //cdate結算日20220207, rdate報價日20220126, tdate交易日20220126/20220127            
        else                          field = 'tdate';

        //歷史
        //strings = [config['getData']['his'],params['sno'],st,period,stocks.exc,gap,stocks.sexc,today];
        //url = strings.join('/');
        //datas = await getData(url,'his');  

        const barsOnScreen = container.clientWidth / CANDLE_WIDTH;  // 計算能在螢幕上顯示的蠟燭數量
        let loop = 0;
        while( loop<5 ){
            const number = 100 * loop;
            datas = await fetchData(number);
            if( datas['candle'].length > barsOnScreen ) break;
            loop++;
        }

        his_last_datas = { ...datas['candle'][datas['candle'].length - 1] };
        if( (period == 2 || period == 3 || period == 4) && (his_lastdate >= opts['init'][field]) ){
            // 已含當日資料
        }else{
            //當日
            strings = [config['getData']['tick'],params['sno'],stocks.exc,stocks.sexc,0,0,period,gap,0]; //sno,exc,sexc,tdate,judge,period,gap,stime
            url = strings.join('/');
            tdatas = await getData(url,'tick');
            datas['candle'] = mergeArrays(datas['candle'], tdatas['candle'],period,'candle');
            datas['line']   = mergeArrays(datas['line'], tdatas['line'],period,'line');
            datas['volume'] = mergeArrays(datas['volume'], tdatas['volume'],period,'volume');
        }
        candleData.set(interval, datas['candle']);
        linesData.set(interval, datas['line']);
        volData.set(interval, datas['volume']);
        
        seriesData = linesData;    
        if( seriestype == 'candleSeries' || seriestype == 'barSeries' ){
            seriesData = candleData;
        }
        setChartInterval(interval,seriestype,seriesData,volData);
        ohlcData = datas['candle'];  //顯示tip用
        if( datas['candle'].length == 0 ){  //無資料
            dataMinTime[interval] = {'time': 0,'fetch':false};
        }else{
            dataMinTime[interval] = {'time': datas['candle'][0]['time'],'fetch':true};
        }
        updateNoDataMessage(datas['candle']);
        isRangeChange = false;
        isShowTip = true;
        const lastData = ohlcData[ohlcData.length - 1];
        showTip(lastData,period);
    //}
}    
function setTimeScale(){
    
    displayedMonths.clear();
    displayedYears.clear();
    chart.applyOptions({
        timeScale: {
            barSpacing: CANDLE_WIDTH,
        },
        priceScale: {
            right: {
                visible: true,
                scaleMargins: {
                    top: 0.1,  // 控制上方圖表的比例（20%留白）
                    bottom: 0.7, // 確保下方圖表佔用 30% 高度
                },
            },
            histogram: {
                visible: true,
                scaleMargins: {
                    top: 0.7,  // 確保上方圖表佔 70% 高度
                    bottom: 0,  // 下方圖表顯示完整
                },
            },
        },
        thinBars: false,  // 設置條形為較寬的格式
        localization: {            
            //priceFormatter: (price) => {  //變全域, 價量無法分
            //    if (price >= 500) {
            //        return Math.round(price);  // 对较大的值（量）进行整数格式化
            //    }
            //    return `${price.toFixed(fi)}`;
            //},
            timeFormatter: time => {
                const date = new Date(time * 1000);
                const year = date.getUTCFullYear();
                const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，所以加1，并确保是两位数
                const day = date.getUTCDate().toString().padStart(2, '0'); // 确保是两位数
                const hours = date.getUTCHours().toString().padStart(2, '0');
                const minutes = date.getUTCMinutes().toString().padStart(2, '0');
                const seconds = date.getUTCSeconds().toString().padStart(2, '0');
                if( interval == '1D' || interval == '1W' || interval == '1M' ){
                    return `${year}-${month}-${day}`;
                }else{
                    return `${year}-${month}-${day} ${hours}:${minutes}`;
                }
            }
        }        
    });
    
    if( interval == '1D' || interval == '1W'){
        chart.applyOptions({
            timeScale: {
                tickMarkFormatter: (time, tickMarkType, locale) => {
                    const date = new Date(time * 1000);
                    const year = date.getFullYear();
                    const month = date.getMonth()+1;
                    const day = date.getDate();
                    const monthIdentifier = `${year}-${month}`;
                    const yearIdentifier = `${year}`;
                    if ( displayedYears.size==0 && displayedMonths.size==0) {  //第一筆資料不顯示
                        displayedYears.add(yearIdentifier);
                        displayedMonths.add(monthIdentifier);
                        return '';
                    }else if (!displayedYears.has(yearIdentifier) && month==1) {
                        displayedYears.add(yearIdentifier);
                        displayedMonths.add(monthIdentifier);
                        return `${year}`;
                    }else if (!displayedMonths.has(monthIdentifier)) {
                        displayedMonths.add(monthIdentifier);
                        //return `${year}-${('0' + (month + 1)).slice(-2)}-${('0' + day).slice(-2)}`;
                        return `${month}月`;
                    }
                    return '';
                }
            }
        });

    }else if( interval == '1M' ){
        
        chart.applyOptions({
            timeScale: {
                tickMarkFormatter: (time, tickMarkType, locale) => {
                    const date = new Date(time * 1000);
                    const year = date.getFullYear();
                    const month = date.getMonth()+1;
                    const day = date.getDate();
                    const yearIdentifier = `${year}`;
                    if (!displayedYears.has(yearIdentifier)) {
                        displayedYears.add(yearIdentifier);
                        return `${year}`;
                    }
                    return '';
                }
            }
        });

    }else{

        chart.applyOptions({
            timeScale: {
                tickMarkFormatter: (time, tickMarkType, locale) => {  //分鐘
                    const date = new Date(time * 1000);
                    const hours = date.getUTCHours().toString().padStart(2, '0');
                    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
                    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
                    //return `${hours}:${minutes}:${seconds}`;
                    return `${hours}:${minutes}`;
                }
            }
        });
    }
}
let previousRange = null;   //紀錄上次range  
let scroll_direction = null;
async function onLogicalRangeChange (newLogicalRange)
{
    try {
        const logicalLeft = newLogicalRange.from;  
        if( previousRange ){
            const previousFrom = previousRange.from;
            if (logicalLeft > previousFrom) {
                scroll_direction = 'right';
            } else if (logicalLeft < previousFrom) {
                scroll_direction = 'left';
            }
        }
        if( scroll_direction == 'right' ){
            const visibleRange = chart.timeScale().getVisibleRange();
            const latestDataTime = datas['candle'][datas['candle'].length - 1].time;
            if (visibleRange && visibleRange.to >= latestDataTime) {
                console.log('目前停在最新資料right');
                isShowTip = true;
                const lastData = ohlcData[ohlcData.length - 1];
                showTip(lastData,period);
            } else {
                //console.log('目前不在最新資料right');
                isShowTip = false;
            } 
            previousRange = newLogicalRange;
            updatePriceLines();
            return;
        }else{
            //console.log('目前不在最新資料left');
            isShowTip = false;
        }
        if( dataMinTime[interval] == undefined || dataMinTime[interval]['fetch'] == false )  //fetch=false查無資料
        {    
            if( dataMinTime[interval]['fetch'] == false && scroll_direction == 'left' ){
                const lastKnownDataTimestamp = dataMinTime[interval]['time'];
                const visibleRange = chart.timeScale().getVisibleRange();
                const leftmostTime = visibleRange.from; // 這是可見範圍內最左邊的時間
                if (leftmostTime == lastKnownDataTimestamp ) {
                    //chart.timeScale().scrollToPosition(chart.timeScale().scrollPosition() - 1, false);
                    showNoDataMessage(chartContainer);
                } else {
                    hideNoDataMessage();
                }
            }
            previousRange = newLogicalRange;
            updatePriceLines();
            return;
        }
        if( logicalLeft < 10 && isRangeChange == false){
            isRangeChange = true;
            datas = await fetchData(100);
            if( dataMinTime[interval]['time'] > datas['candle'][0]['time'] ){   //candle第一筆是最小日期
                his_last_datas = { ...datas['candle'][datas['candle'].length - 1] };
                let field = 'tdate';
                if( opts['init']['exc']==12 ) field = 'cdate';
                if( (period == 2 || period == 3 || period == 4) && (his_lastdate >= opts['init'][field]) ){
                    // 已含當日資料
                }else{
                    //當日
                    strings = [config['getData']['tick'],params['sno'],stocks.exc,stocks.sexc,0,0,period,gap,0];
                    url = strings.join('/');
                    tdatas = await getData(url,'tick');
                    datas['candle'] = mergeArrays(datas['candle'], tdatas['candle'],period,'candle');
                    datas['line']   = mergeArrays(datas['line'], tdatas['line'],period,'line');
                    datas['volume'] = mergeArrays(datas['volume'], tdatas['volume'],period,'volume');
                }
                candleData.set(interval, datas['candle']);
                linesData.set(interval, datas['line']);
                volData.set(interval, datas['volume']);

                seriesData = linesData;    
                if( seriestype == 'candleSeries' || seriestype == 'barSeries' ) seriesData = candleData;
                currentSeries.setData(seriesData.get(interval));
                volumeSeries.setData(volData.get(interval));
                
                isRangeChange = false;
                ohlcData = datas['candle'];  //顯示tip用
                dataMinTime[interval]['time'] = datas['candle'][0]['time'];
            }else{
                dataMinTime[interval]['fetch'] = false;
                isRangeChange = false;
                showNoDataMessage(chartContainer);
            }
        }
        updatePriceLines();
        
    } catch (error) {
        console.error('Error fetching data:', error);
    }
    previousRange = newLogicalRange;
}
let isUpdatePriceLines = false;
function updatePriceLines()
{
    if( isUpdatePriceLines == true ) return;
    const visibleRange = chart.timeScale().getVisibleRange();    
    if (visibleRange) {
        isUpdatePriceLines = true;
        const from  = visibleRange.from;
        const to = visibleRange.to;
        const visibleData = seriesData.get(interval).filter((bar) => {
            return bar.time >= from && bar.time <= to;
        });        
        let highestPrice,lowestPrice;
        if( seriestype == 'candleSeries' || seriestype == 'barSeries' ){
            highestPrice = Math.max(...visibleData.map(bar => bar.high));
            lowestPrice = Math.min(...visibleData.map(bar => bar.low));
        }else{
            highestPrice = Math.max(...visibleData.map(bar => bar.value));
            lowestPrice = Math.min(...visibleData.map(bar => bar.value));
        }
        if( minPriceLine )  currentSeries.removePriceLine(minPriceLine);
        if( maxPriceLine )  currentSeries.removePriceLine(maxPriceLine);
        minPriceLine = currentSeries.createPriceLine({
            price: lowestPrice,
            color: '#26a69a',
            lineWidth: lineWidth,
            lineStyle: 2, // LineStyle.Dashed
            axisLabelVisible: true,
            title: '最低',
        });
        maxPriceLine = currentSeries.createPriceLine({
            price: highestPrice,
            color: '#ef5350',
            lineWidth: lineWidth,
            lineStyle: 2, // LineStyle.Dashed
            axisLabelVisible: true,
            title: '最高',
        });
        // 添加最大量標記       
        const vData = volData.get(interval).filter((bar) => {
            return bar.time >= from && bar.time <= to;
        });        
        const maxVolumePoint = vData.reduce((max, point) => point.value > max.value ? point : max, vData[0]);
        const markers = [
            {
                time: maxVolumePoint.time,
                position: 'aboveBar',  //aboveBar,belowBar,inBar
                color: 'yellow',
                shape: 'arrowUp',
                text: `${maxVolumePoint.value}`,
            }
        ];
        markers.forEach(marker => {
            const logicalTime = chart.timeScale().timeToCoordinate(marker.time);
            if (logicalTime < 50) {
                //marker.text = '→   ' + marker.text;
                marker.text = '   　 ' + marker.text;
            } else if (logicalTime > chart.options().width - 60) {
                //marker.text = marker.text + ' ←';
                marker.text = marker.text + '   　 ';
            }
        });
        volumeSeries.setMarkers(markers);
    }
    isUpdatePriceLines = false;
}
